import { useEffect, useState } from "react";
import ClientList from "./ClientList";
import ClientProfile from "./ClientProfile";

export default function Clients({ state, dashboard, ghl, dateFilter, initialClientId, onClearInitialClient }) {
  const [selectedId, setSelectedId] = useState(initialClientId || null);

  useEffect(() => {
    if (initialClientId && initialClientId !== selectedId) {
      setSelectedId(initialClientId);
      onClearInitialClient?.();
    }
  }, [initialClientId, selectedId, onClearInitialClient]);

  // state.payments is already the merged universe (manual + GHL + overrides)
  // since App.jsx now does that once at the top. No need to re-merge here.

  if (selectedId) {
    return (
      <ClientProfile
        clientId={selectedId}
        state={state}
        dashboard={dashboard}
        ghl={ghl}
        onBack={() => setSelectedId(null)}
      />
    );
  }

  return (
    <ClientList
      clients={state.clients}
      offers={state.offers}
      payments={state.payments}
      settings={state.settings}
      dateFilter={dateFilter}
      onAdd={dashboard.addClient}
      onUpdate={dashboard.updateClient}
      onSetStatus={dashboard.setClientStatus}
      onCreateOffer={dashboard.addOffer}
      onBulkDelete={dashboard.deleteClientsBulk}
      onMerge={dashboard.mergeClients}
      onSelect={setSelectedId}
      onCreateScheduledPayments={dashboard.addPaymentsBulk}
    />
  );
}